import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { scrollToId } from "../lib/scroll";
import { IkonsMark } from "./IkonsMark";

const SECTIONS = [
  "inicio",
  "perfil",
  "estadisticas",
  "analisis",
  "videos",
  "galeria",
  "mercado",
  "contacto",
];

export const Navbar = () => {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-ink-700/60 bg-ink-950/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <button
          data-testid="header-logo-link"
          onClick={() => go("inicio")}
          className="flex items-center gap-3"
          aria-label="IKONS · Cristian Díaz Ferrada"
        >
          <IkonsMark className="h-7" />
          <span className="hidden h-6 w-px bg-ink-600/80 sm:block" aria-hidden="true" />
          <span
            className="font-display text-base font-semibold uppercase leading-none tracking-wide text-white sm:text-lg"
            data-testid="header-player-name"
          >
            <span className="text-kit">Cristian</span> Díaz Ferrada
          </span>
        </button>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Principal">
          {SECTIONS.slice(1).map((id) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-300 transition-colors duration-200 hover:text-kit"
            >
              {t.nav[id]}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            className="flex items-center border border-ink-600/70 font-mono text-[11px] font-semibold"
            role="group"
            aria-label="Idioma / Language"
          >
            <button
              data-testid="language-selector-es"
              onClick={() => setLang("es")}
              className={`px-2.5 py-1.5 transition-colors duration-200 ${
                lang === "es"
                  ? "bg-kit text-ink-950"
                  : "text-zinc-400 hover:text-white"
              }`}
            >
              ES
            </button>
            <button
              data-testid="language-selector-en"
              onClick={() => setLang("en")}
              className={`px-2.5 py-1.5 transition-colors duration-200 ${
                lang === "en"
                  ? "bg-kit text-ink-950"
                  : "text-zinc-400 hover:text-white"
              }`}
            >
              EN
            </button>
          </div>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="p-2 text-white lg:hidden"
            aria-label={t.nav.menu}
            aria-expanded={open}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-ink-700/60 bg-ink-950/95 px-4 py-4 backdrop-blur-md lg:hidden"
          aria-label="Menú móvil"
        >
          <div className="grid grid-cols-2 gap-1">
            {SECTIONS.slice(1).map((id) => (
              <button
                key={id}
                data-testid={`mobile-nav-link-${id}`}
                onClick={() => go(id)}
                className="px-3 py-3 text-left text-sm font-semibold uppercase tracking-[0.12em] text-zinc-200 transition-colors duration-200 hover:text-kit"
              >
                {t.nav[id]}
              </button>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
